import styled from 'styled-components';

import { mediaConfined, mediaXWide } from '@xing-com/layout-tokens';
import { scale170, scale230, space3XL, space5XL } from '@xing-com/tokens';
import { GridContainer } from '@xing-com/xing-grid';

export const StyledSection = styled.section`
  padding: ${scale170} 0;

  @media ${mediaConfined} {
    padding: ${space3XL} 0 ${space5XL} 0;
  }
`;

export const StyledGridContainer = styled(GridContainer)`
  @media ${mediaConfined} {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media ${mediaXWide} {
    gap: ${scale230};
  }
`;
